import { render } from "./PopUpShareResource.vue?vue&type=template&id=00fbbcea"
import script from "./PopUpShareResource.vue?vue&type=script&lang=js"
export * from "./PopUpShareResource.vue?vue&type=script&lang=js"

import "./PopUpShareResource.vue?vue&type=style&index=0&id=00fbbcea&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__